import { useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { ImportResultPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ImportResultModal } from 'modules/compensations/components/importResultModal'

const ResultsPage = ({ closePath }: { closePath: ((id: string) => string) | string }) => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [searchParams] = useSearchParams()
  const payrollRunId = parseInt(searchParams.get('payroll-run-id') || '0')

  const { data, error, loading } = useQuery(ImportResultPageDocument, {
    fetchPolicy: 'network-only',
  })

  const canUseUniversalImporters = data?.universalImporter?._policies.importResources.can
  const authorized = canUseUniversalImporters && !error

  useEffect(() => {
    if (!loading && data && !authorized) {
      navigate(-1)
    }
  }, [loading, data, authorized, navigate])

  const onClose = () => {
    navigate(typeof closePath === 'function' ? closePath(id || '') : closePath)
  }

  if (loading) {
    return (
      <Box justifyContent="center" alignItems="center" height="full">
        <Spinner />
      </Box>
    )
  }

  if (data && !authorized) {
    return null
  }

  return <ImportResultModal onClose={onClose} payrollRunId={payrollRunId} />
}

export default ResultsPage
